

const ButtonBigWithAction = ({type = 'button', addClass = null, title, ...props}) => {
    
        return (
            <button type={type} className={`p-2 min-w-[120px] ${addClass}`} {...props}>{title}</button>
        );
}

export default ButtonBigWithAction